/**
 * @botto/module-tariffs — Billing / Multicurrency module.
 *
 * Owns: routes /tariffs/*, side-menu «Тарифы».
 * Publishes countries + currencies lookups via @botto/core/stores for SMS/CDP.
 */
import type { ModuleManifest } from '@botto/core';
import { registerLookups } from '@botto/core';
import { routes } from './routes';
import { menu } from './menu';
import { fetchCountries, fetchCurrencies } from './api/lookups';

const manifest: ModuleManifest = {
  id: 'tariffs',
  title: 'Тарифы',
  routes,
  menu,
  init() {
    registerLookups({
      countries: fetchCountries,
      currencies: fetchCurrencies,
    });
  },
};

export default manifest;
